import {
  FD_DUE_DATE_REPORT,
  FD_UNREALIZED_HOLDING_COLUMNS,
  FieldColumn,
  getColumnsForFdReportType,
  INVESTOR_COLUMN,
} from "./fdReportConfig";

export const REPORT_BUILDER_VISIBLE_COLUMN_COUNT = 7;

const buildFdHoldingColumns = (includeAvgDays: boolean): FieldColumn[] =>
  includeAvgDays
    ? FD_UNREALIZED_HOLDING_COLUMNS
    : FD_UNREALIZED_HOLDING_COLUMNS.filter((c) => c.key !== "days");

export const getBaseColumnsForReportType = (reportType: string): FieldColumn[] => {
  switch (reportType) {
    case "Holding":
      return buildFdHoldingColumns(true);
    case FD_DUE_DATE_REPORT:
      return buildFdHoldingColumns(false);
    default:
      return getColumnsForFdReportType(reportType);
  }
};

export const buildSelectableColumns = (reportType: string): FieldColumn[] => [
  INVESTOR_COLUMN,
  ...getBaseColumnsForReportType(reportType),
];

export const buildEffectiveColumns = (
  reportType: string,
  visibleColumnKeys: string[],
): FieldColumn[] => {
  let columns = buildSelectableColumns(reportType);
  if (visibleColumnKeys.length > 0) {
    const visible = new Set(visibleColumnKeys);
    columns = columns.filter((c) => visible.has(c.key));
  }
  return columns;
};

export const getDefaultVisibleColumnKeys = (reportType: string): string[] =>
  buildSelectableColumns(reportType).map((c) => c.key);
